import React, { useEffect, useState } from 'react'
import styles from "../../pages/OnBoarding/UserOnboarding.module.css";
import pass from "./LoginForm.module.css"   
import cogoToast from "cogo-toast-react-17-fix";
import API from "../../ApiConfig"
import { BASE_URL, SEND_ONBOARD_EMAIL, SEND_ONBOARD_EMAIL_VERIFIER, SET_PASSWORD, USER_TOKEN, VERIFY_TOKEN } from "../../Utils/constant";
import { AuthConsole, Delay, EMAIL_CHECK, NAME_CHECK_WITH_NUMBER } from "../../Utils/helper";
import BtnLoader from "../BtnLoader";
import SlideUpWrapper from "../Transitions/SlideUpWrapper";
import RightContent1 from "./login_right";
import Loader from "../Loader";
import useRefreshToken from "../../Hooks/usegenerateToken";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { BUTTONS } from "../../Utils/Strings";
import { Icon } from 'react-icons-kit'
import {basic_eye} from 'react-icons-kit/linea/basic_eye';
import {basic_eye_closed} from 'react-icons-kit/linea/basic_eye_closed'
import addIssuer from '../../pages/DashBoard/addIssuer.module.css'
const OnboardUsers = () => {
    const { token } = useParams();
    const [searchParams] = useSearchParams();
    const email = searchParams.get('email')
      const [password,setPassword]=useState('');
      const [confirmPassword,setConfirmPassword]=useState('');
      const [loading,setLoading]=useState(false);
      const [passVisible,setPassVisible]=useState({
          setPass:false,
          confirmPass:false
      })
      const [userForm, setUserForm] = useState({
        company_name: "",
        email: "",
        company_alias: "",
      })
      const [userError, setUserError] = useState({})
      const location=useLocation()
      
      const navigate=useNavigate();
      const handleResetPassword=async (e)=>{
          e.preventDefault()
          if(ValidatePass()){
              let PassData={
                  email:email,
                  token:token,
                  new_password:password,
                  confirm_password:confirmPassword
              }
              setLoading(true)
              await Delay()
              API.put(SET_PASSWORD,{...PassData})
              .then(res=>{
                  setLoading(false)
                  if(res.status==200){
                      cogoToast.success(res.data.message)  
                      navigate('/app/verify')              
                  }
              })
              .catch(err=>{
                  setLoading(false)
                  cogoToast.error(err.response.data.detail)
              })
          }
          }
          const ValidatePass=()=>{
              if(password===""){
                  cogoToast.error("Please enter Password")
                  return false;
                }
                if(confirmPassword===""){
                  cogoToast.error("Please confirm your Password")
                  return false;
                }
            
                if(confirmPassword!=password){
                  cogoToast.error("Confirm password and password did not match")
                  return false;
                }
                return true;
          }
          const handleVisibility=(field)=>{
              
              setPassVisible((prevState) => ({
                  ...prevState,
                  [field]: !prevState[field]
                }))
          }

          const handleAddUser = async (e) => {
            e.preventDefault();
            let isValid = true;
            let tempError = { ...userError };
            if (userForm.issuer == "verifier") {

                userForm.category = "3"
            }
            Object.keys(userForm).map((item) => {
              if (userForm[item].length === 0) {
                isValid = false;
                tempError[item] = true;
              } else if (item === "email" && !EMAIL_CHECK(userForm[item])) {
                isValid = false;
                tempError[item] = true;
              } else if (item === "company_name" && !NAME_CHECK_WITH_NUMBER(userForm[item])) {
                isValid = false;
                tempError[item] = true;
              }
              if (item === "company_alias" && userForm[item] == '') {
                isValid = true;
                tempError[item] = false;
              } else if (item === "company_alias" && !NAME_CHECK_WITH_NUMBER(userForm[item])) {
                isValid = false;
                tempError[item] = true;
              }
            });
            const emailAPI = userForm.issuer === "issuer" ? SEND_ONBOARD_EMAIL : userForm.issuer === "verifier" ? SEND_ONBOARD_EMAIL_VERIFIER : null;
            if (emailAPI == null) {
              isValid = false
              tempError["issuer"] = true;
            }
            setUserError(tempError);
      
            if (!isValid) return;
      
            setLoading(true);
            await Delay();
            API.post(emailAPI, userForm)
              .then((res) => {
                setLoading(false);
                if (res.status === 200) {
                  cogoToast.success("Link Sent to " + userForm.email);
                  setPopup(false);
                  getUsers()
                } else {
                  cogoToast.error(
                    userForm.issuer == "issuer"
                      ? "Issuer cannot be added"
                      : "verifier cannot be"
                  );
                }
              })
              .catch((err) => {
                setLoading(false);
                setPopup(false);
                cogoToast.error(err.response.data.message);
              });
          }
          function handleChange(e) {
                let { name, value } = e.target;
                let tempForm = { ...userForm };
                let tempError = { ...userError };
                tempForm[name] = value;
                if (name === "email" && EMAIL_CHECK(value)) {
                  delete tempError.email;
                }
                if (name === "company_name" && NAME_CHECK(value)) {
                  AuthConsole('company name', tempError.name)
                  delete tempError.company_name;
                }
                if (name === "company_alias" && value == '') {
                  delete tempError.company_alias;
                } else if (name === "company_alias" && NAME_CHECK(value)) {
                  delete tempError.company_alias;
                } else if (name === "company_alias" && !NAME_CHECK(value)) {
                  tempError.company_alias = true
                }
                if (name === "issuer" && value.length > 0) {
                  delete tempError.issuer;
                }
                if (value === "verifier") {
                  setSelectVerifierType(true)
                }
                else if (value === "issuer") {
                  setSelectVerifierType(false)
                }
                AuthConsole('errrrrrrrr', tempError)
                setUserError(tempError);
                setUserForm(tempForm);
              }
              function handleDocumentChange(e) {
                setVerifierType(e)
              }
  return (
        <SlideUpWrapper direction="slide-left">
        <div className={styles.userOnboarding}>
            <Loader isOpen={loading}/>
            <form className={pass.leftContent} onSubmit={(e) => handleAddUser(e)}>
                    <Loader isOpen={loading} />
                    <div className={addIssuer.modalBody}>
                      Select issuer Type:
                      <div className={addIssuer.radioBtn}>
                        <label>
                          <input
                            type="radio"
                            value="issuer"
                            name="issuer"
                            onChange={handleChange}
                          />
                          Issuer
                        </label>
                        <label>
                          <input
                            type="radio"
                            value="verifier"
                            name="issuer"
                            onChange={handleChange}
                          />
                          Verifier
                        </label>
                        {userError?.issuer ? (
                          <p style={{ color: "red" }}>Please select issuer type!</p>
                        ) : null}
                      </div>
                      {/* {selectVerifierType &&
                        <CustomDropDown list={['General', 'Visitor', 'Employment']} selectedOption={verifierType} onSelect={e => handleDocumentChange(e)} />} */}
                      {/* {userError?.category ? (
                        <p style={{ color: "red" }}>Please chose Verifier type</p>
                      ) : null} */}
                      <label className={addIssuer.required}>Company Name </label>
                      <div className={addIssuer.emailInput}>
                        <input
                          name="company_name"
                          className={addIssuer.input}
                          placeholder="Company Name"
                          value={userForm.company_name}
                          onChange={handleChange}
                        />
                        {userError?.company_name ? (
                          <p style={{ color: "red" }}>
                            Please Enter a Valid Company name !!
                          </p>
                        ) : null}
                      </div>
                      <label>Company Alias(optional) </label>
                      <div className={addIssuer.emailInput}>
                        <input
                          name="company_alias"
                          className={addIssuer.input}
                          placeholder="Company Alias"
                          value={userForm.company_alias}
                          onChange={handleChange}
                        />
                        {userError?.company_alias ? (
                          <p style={{ color: "red" }}>
                            Please Enter a Valid Company alias !!
                          </p>
                        ) : null}
                      </div>
            
                      <label className={addIssuer.required}>Your email </label>
                      <div className={addIssuer.emailInput}>
                        <input
                          name="email"
                          className={addIssuer.input}
                          placeholder="name@example.com"
                          value={userForm.email}
                          onChange={handleChange}
                        />
                        {userError?.email ? (
                          <p style={{ color: "red" }}>Please Enter a Valid Email!</p>
                        ) : null}
                      </div>
                      <div
                        className={addIssuer.popBtn}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-end",
                          alignItems: "center",
                        }}
                      >
                        <div className={addIssuer.btn1}>
                          <button onClick={() => setPopup(false)} className="secondaryBtn">{BUTTONS.CANCEL}</button>
                        </div>
                        <div className={addIssuer.btn}>
                          <button type="btn btn-primary" disabled={loading} className="Modalbutton">
                            {loading ? BUTTONS.ADDING : "Add User"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
      <RightContent1 />
        </div>
        </SlideUpWrapper>
  )
}

export default OnboardUsers